import { Heading, Text } from '@orbita-ui/core';
import styled from 'styled-components';

export const CardSectionTitle = styled(Heading).attrs({
  bold: true,
  size: 'xl',
})`
  margin-top: 0px;
  margin-bottom: 1rem;
`;

export const CardInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 0.3fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 1.6rem;
`;

export const CardHolderAdressesContainer = styled.div`
  margin-bottom: 1.6rem;
`;

export const CardHolderAdressesTitle = styled(Heading).attrs({
  size: 'l',
})`
  text-transform: capitalize;
  margin-bottom: 1rem;
`;

export const CardHolderCardsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CardHolderCardsContainerText = styled(Text).attrs({
  color: 'info',
})`
  margin-left: 0.5rem;
`;
